import apiClient from '@/services/api'

export default {
  setAlert({ commit, state }, payload) {
    const newAlert = payload
    const oldItems = state.alerts

    const newItems = [
      ...oldItems.map(item => {
        if (item.id === payload.id) {
          return newAlert
        }

        return item
      })
    ]

    commit('setAlert', newAlert)
    commit('setAlerts', newItems)
  },

  async getAlerts({ rootState, commit }, { page, size, filter }) {
    try {
      const { data } = await apiClient.post(
        '/api/alert/project/get_all',
        {
          page,
          size,
          project_id: rootState.applicationState.currentProject.id,
          filter
        },
        {
          cancelPreviousRequests: true
        }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setAlerts', data.items)

      return data
    } catch (error) {
      throw error.message
    }
  },

  async getAlertsCount({ rootState, commit }) {
    try {
      const { data } = await apiClient.post('/api/alert/project/counts', {
        project_id: rootState.applicationState.currentProject.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('setAlertsCount', data.counts)
    } catch (error) {
      throw error.message
    }
  },

  async getAlert({ rootState, state, commit }, { id }) {
    if (state.alerts.some(item => item.id === id && item.data)) {
      commit(
        'setAlert',
        state.alerts.find(item => item.id === id)
      )

      return
    }

    try {
      const { data } = await apiClient.post(`/api/alert/${id}/get`, {
        project_id: rootState.applicationState.currentProject.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      const oldItems = state.alerts

      const newItems = [
        ...oldItems.map(item => {
          if (item.id === id) {
            return data.alert
          }

          return item
        })
      ]

      commit('setAlerts', newItems)

      commit('setAlert', data.alert)
    } catch (error) {
      throw error.message
    }
  },

  async deleteAlert({ state, commit }, { alert_id }) {
    try {
      const { data } = await apiClient.post('/api/alert/delete', {
        alert_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit(
        'setAlerts',
        state.alerts.filter(item => item.id !== alert_id)
      )
    } catch (error) {
      throw error.message
    }
  },

  removeWorkerAssignmentReviewAlert({ state, commit }, { requestId }) {
    const alerts = state.alerts.filter(alert => alert.data?.worker_assignment_request_id !== requestId)
    commit('setAlerts', alerts)

    if (state.alert?.data?.worker_assignment_request_id === requestId) {
      commit('setAlert', null)
    }
  },

  // uncompleted tasks

  async getUncompletedTasks({ rootState }, { page, size, filter }) {
    const project_id = rootState.applicationState.currentProject.id
    const manager_scopes = rootState.applicationState.associate.manager_scopes

    try {
      const { data } = await apiClient.get(
        `/api/project/${project_id}/uncompleted_tasks/associate/count?fields={*,associate{first_name,last_name,photo_url,associate_number,role{name},is_verified,payment_info,uncompleted_task_attempts_count,id}}`,
        {
          params: {
            page,
            size,
            ...filter,
            manager_scopes: encodeURIComponent(JSON.stringify(manager_scopes))
          },
          cancelPreviousRequests: true
        }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async getAssociateUncompletedTasks({ rootState }, { associate_id }) {
    if (!associate_id) {
      return {
        tasks: []
      }
    }

    const project_id = rootState.applicationState.currentProject.id
    const manager_scopes = rootState.applicationState.associate.manager_scopes

    try {
      const { data } = await apiClient.get(
        `/api/project/${project_id}/uncompleted_tasks/associate/${associate_id}?fields={tasks{title,severity,details,created_at,id},associate{first_name,last_name,photo_url,associate_number,role{name},is_verified,payment_info,id}}`,
        {
          params: {
            manager_scopes: encodeURIComponent(JSON.stringify(manager_scopes))
          }
        }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.uncompleted_critical_task
    } catch (error) {
      throw error.message
    }
  },

  // notifications
  async getNotifications({ rootState }, _) {
    const project_id = rootState.applicationState.currentProject.id

    try {
      const { data } = await apiClient.get('/api/project/notification', {
        params: {
          project_id
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async postNotification({ rootState }, { notification }) {
    const project_id = rootState.applicationState.currentProject.id
    const author_id = rootState.applicationState.associate.id

    try {
      const { data } = await apiClient.post('/api/project/notification/send', {
        project_id,
        author_id,
        ...notification
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(data.msg)
      }
    } catch (error) {
      throw error.message
    }
  },

  async deleteNotification(_, { id }) {
    try {
      const { data } = await apiClient.delete(`/api/project/notification/${id}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(data.msg)
      }
    } catch (error) {
      throw error.message
    }
  }
}
